/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Reflex API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateServiceAccount201
} from './model/createServiceAccount201.js';

import type {
  CreateServiceAccountApiKey201
} from './model/createServiceAccountApiKey201.js';

import type {
  CreateServiceAccountApiKeyBody
} from './model/createServiceAccountApiKeyBody.js';

import type {
  CreateServiceAccountBody
} from './model/createServiceAccountBody.js';

import type {
  ListServiceAccountApiKeys200
} from './model/listServiceAccountApiKeys200.js';

import type {
  ListServiceAccounts200
} from './model/listServiceAccounts200.js';

import { apiFetch } from '../react-mutator.js';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary List the organization's service accounts.
 */
export const listServiceAccounts = (

 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ListServiceAccounts200>(
      {url: `/service-accounts`, method: 'GET', signal
    },
      options);
    }




export const getListServiceAccountsQueryKey = () => {
    return [
    `/service-accounts`
    ] as const;
    }


export const getListServiceAccountsQueryOptions = <TData = Awaited<ReturnType<typeof listServiceAccounts>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listServiceAccounts>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListServiceAccountsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listServiceAccounts>>> = ({ signal }) => listServiceAccounts(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listServiceAccounts>>, TError, TData> & { queryKey: QueryKey }
}

export type ListServiceAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof listServiceAccounts>>>
export type ListServiceAccountsQueryError = unknown


/**
 * @summary List the organization's service accounts.
 */

export function useListServiceAccounts<TData = Awaited<ReturnType<typeof listServiceAccounts>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listServiceAccounts>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListServiceAccountsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Creates a machine identity in the active organization and grants it the chosen org role.
 * @summary Create a service account.
 */
export const createServiceAccount = (
    createServiceAccountBody: CreateServiceAccountBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<CreateServiceAccount201>(
      {url: `/service-accounts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createServiceAccountBody, signal
    },
      options);
    }




export const getCreateServiceAccountMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createServiceAccount>>, TError,{data: CreateServiceAccountBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createServiceAccount>>, TError,{data: CreateServiceAccountBody}, TContext> => {

const mutationKey = ['createServiceAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createServiceAccount>>, {data: CreateServiceAccountBody}> = (props) => {
          const {data} = props ?? {};

          return  createServiceAccount(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateServiceAccountMutationResult = NonNullable<Awaited<ReturnType<typeof createServiceAccount>>>
    export type CreateServiceAccountMutationBody = CreateServiceAccountBody
    export type CreateServiceAccountMutationError = unknown

    /**
 * @summary Create a service account.
 */
export const useCreateServiceAccount = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createServiceAccount>>, TError,{data: CreateServiceAccountBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createServiceAccount>>,
        TError,
        {data: CreateServiceAccountBody},
        TContext
      > => {
      return useMutation(getCreateServiceAccountMutationOptions(options));
    }
    /**
 * @summary Delete a service account and revoke all of its API keys.
 */
export const deleteServiceAccount = (
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/service-accounts/${encodeURIComponent(String(id))}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteServiceAccountMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteServiceAccount>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteServiceAccount>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteServiceAccount'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteServiceAccount>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteServiceAccount(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteServiceAccountMutationResult = NonNullable<Awaited<ReturnType<typeof deleteServiceAccount>>>

    export type DeleteServiceAccountMutationError = unknown

    /**
 * @summary Delete a service account and revoke all of its API keys.
 */
export const useDeleteServiceAccount = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteServiceAccount>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteServiceAccount>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteServiceAccountMutationOptions(options));
    }
    /**
 * @summary List a service account's API keys.
 */
export const listServiceAccountApiKeys = (
    id: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<ListServiceAccountApiKeys200>(
      {url: `/service-accounts/${encodeURIComponent(String(id))}/keys`, method: 'GET', signal
    },
      options);
    }




export const getListServiceAccountApiKeysQueryKey = (id: string,) => {
    return [
    `/service-accounts/${id}/keys`
    ] as const;
    }


export const getListServiceAccountApiKeysQueryOptions = <TData = Awaited<ReturnType<typeof listServiceAccountApiKeys>>, TError = unknown>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listServiceAccountApiKeys>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListServiceAccountApiKeysQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listServiceAccountApiKeys>>> = ({ signal }) => listServiceAccountApiKeys(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listServiceAccountApiKeys>>, TError, TData> & { queryKey: QueryKey }
}

export type ListServiceAccountApiKeysQueryResult = NonNullable<Awaited<ReturnType<typeof listServiceAccountApiKeys>>>
export type ListServiceAccountApiKeysQueryError = unknown


/**
 * @summary List a service account's API keys.
 */

export function useListServiceAccountApiKeys<TData = Awaited<ReturnType<typeof listServiceAccountApiKeys>>, TError = unknown>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listServiceAccountApiKeys>>, TError, TData>, request?: SecondParameter<typeof apiFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListServiceAccountApiKeysQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * The plaintext token is returned once in this response and can never be retrieved again.
 * @summary Mint an API key for a service account.
 */
export const createServiceAccountApiKey = (
    id: string,
    createServiceAccountApiKeyBody: CreateServiceAccountApiKeyBody,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<CreateServiceAccountApiKey201>(
      {url: `/service-accounts/${encodeURIComponent(String(id))}/keys`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createServiceAccountApiKeyBody, signal
    },
      options);
    }




export const getCreateServiceAccountApiKeyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createServiceAccountApiKey>>, TError,{id: string;data: CreateServiceAccountApiKeyBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createServiceAccountApiKey>>, TError,{id: string;data: CreateServiceAccountApiKeyBody}, TContext> => {

const mutationKey = ['createServiceAccountApiKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createServiceAccountApiKey>>, {id: string;data: CreateServiceAccountApiKeyBody}> = (props) => {
          const {id,data} = props ?? {};

          return  createServiceAccountApiKey(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateServiceAccountApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof createServiceAccountApiKey>>>
    export type CreateServiceAccountApiKeyMutationBody = CreateServiceAccountApiKeyBody
    export type CreateServiceAccountApiKeyMutationError = unknown

    /**
 * @summary Mint an API key for a service account.
 */
export const useCreateServiceAccountApiKey = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createServiceAccountApiKey>>, TError,{id: string;data: CreateServiceAccountApiKeyBody}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createServiceAccountApiKey>>,
        TError,
        {id: string;data: CreateServiceAccountApiKeyBody},
        TContext
      > => {
      return useMutation(getCreateServiceAccountApiKeyMutationOptions(options));
    }
    /**
 * @summary Revoke one of a service account's API keys.
 */
export const revokeServiceAccountApiKey = (
    id: string,
    keyId: string,
 options?: SecondParameter<typeof apiFetch>,signal?: AbortSignal
) => {


      return apiFetch<void>(
      {url: `/service-accounts/${encodeURIComponent(String(id))}/keys/${encodeURIComponent(String(keyId))}`, method: 'DELETE', signal
    },
      options);
    }




export const getRevokeServiceAccountApiKeyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeServiceAccountApiKey>>, TError,{id: string;keyId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof revokeServiceAccountApiKey>>, TError,{id: string;keyId: string}, TContext> => {

const mutationKey = ['revokeServiceAccountApiKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof revokeServiceAccountApiKey>>, {id: string;keyId: string}> = (props) => {
          const {id,keyId} = props ?? {};

          return  revokeServiceAccountApiKey(id,keyId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RevokeServiceAccountApiKeyMutationResult = NonNullable<Awaited<ReturnType<typeof revokeServiceAccountApiKey>>>

    export type RevokeServiceAccountApiKeyMutationError = unknown

    /**
 * @summary Revoke one of a service account's API keys.
 */
export const useRevokeServiceAccountApiKey = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof revokeServiceAccountApiKey>>, TError,{id: string;keyId: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof revokeServiceAccountApiKey>>,
        TError,
        {id: string;keyId: string},
        TContext
      > => {
      return useMutation(getRevokeServiceAccountApiKeyMutationOptions(options));
    }
